module.exports = __webpack_public_path__ + "media/images/messagecards/pink-62e72934312251b1391af9499be5440c.jpg";